/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DefinitionNameLabel = {
    AreaFlatnessAreaRatio: 'AreaFlatnessAreaRatio',
    AreaFlatnessCaxRatio: 'AreaFlatnessCAXRatio',
    BeamProfileConstancyAapmTg14220090817: 'BeamProfileConstancyAAPM_TG142_20090817',
    BeamQualityFactorUnicheck: 'BeamQualityFactorUnicheck',
    CaxDeviationPenumbraFitInfl: 'CAXDeviationPenumbraFitINFL',
    CaxDeviationPenumbraFitLevel: 'CAXDeviationPenumbraFitLevel',
    FlatnessAreaRatio: 'FlatnessAreaRatio',
    FlatnessCaxRatio: 'FlatnessCAXRatio',
    NonSpecificDose: 'NonSpecificDose',
    RadFieldSizeByPenumbraFitInfl: 'RadFieldSizeByPenumbraFitINFL',
    RadFieldSizeByPenumbraFitLevel: 'RadFieldSizeByPenumbraFitLevel',
    StabilityIndexAnsmPenumbraFitInfl: 'StabilityIndexAnsmPenumbraFitINFL',
    StabilityIndexAnsmPenumbraFitLevel: 'StabilityIndexAnsmPenumbraFitLevel',
    SymmetryArea: 'SymmetryArea',
    SymmetryIsodose: 'SymmetryIsodose',
    SymmetryPercOfFs: 'SymmetryPercOfFS',
    UnicheckAirPressure: 'UnicheckAirPressure',
    UnicheckAirTemperature: 'UnicheckAirTemperature',
    FlattenedAreaDdLarge: 'FlattenedAreaDdLarge',
    FlattenedAreaDdMid: 'FlattenedAreaDdMid',
    FlattenedAreaDdSmall: 'FlattenedAreaDdSmall',
    FlattenedAreaDmLarge: 'FlattenedAreaDmLarge',
    FlattenedAreaDmMid: 'FlattenedAreaDmMid',
    FlattenedAreaDmSmall: 'FlattenedAreaDmSmall',
    FlattenedAreaLowerRangeLargeRadiationFields: 'FlattenedAreaLowerRangeLargeRadiationFields',
    FlattenedAreaLowerRangeMidRadiationFields: 'FlattenedAreaLowerRangeMidRadiationFields',
    FlattenedAreaLowerRangeSmallRadiationFields: 'FlattenedAreaLowerRangeSmallRadiationFields',
    HorizontalChamberDistance: 'HorizontalChamberDistance',
    IsodoseDmin: 'IsodoseDmin',
    PercOfAbsDose: 'PercOfAbsDose',
    PercOfNominalFs: 'PercOfNominalFS',
    VerticalChamberDistance: 'VerticalChamberDistance'
} as const;
export type DefinitionNameLabel = typeof DefinitionNameLabel[keyof typeof DefinitionNameLabel];


export function DefinitionNameLabelFromJSON(json: any): DefinitionNameLabel {
    return DefinitionNameLabelFromJSONTyped(json, false);
}

export function DefinitionNameLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionNameLabel {
    return json as DefinitionNameLabel;
}

export function DefinitionNameLabelToJSON(value?: DefinitionNameLabel | null): any {
    return value as any;
}

/**
 * Check if a given object implements the DefinitionNameLabel interface.
 */
 export function instanceOfDefinitionNameLabel(value: any): value is DefinitionNameLabel {
    return Object.values(DefinitionNameLabel).includes(value)
}

